export default __webpack_public_path__ + "01f03aa7d1785fd3a0b7b88990030b90.svg";